export const SELECT_CURRICULUM = 'SELECT_CURRICULUM';
export const SELECT_LECTURE = 'SELECT_LECTURE';

export const TOGGLE_SUBSCRIPTION = 'TOGGLE_SUBSCRIPTION';

export const COMPLETE_LECTURE = 'COMPLETE_LECTURE';
